import "core-js/modules/es6.function.name";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.array.from";
import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";
import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.array.find";
import "core-js/modules/es6.regexp.replace";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.array.find-index";
import "core-js/modules/web.dom.iterable";

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import ApiService from '../../../../services/apiService';
import { mapState } from 'vuex';
import momentTZ from 'moment-timezone';
import { isArray, cloneDeep, pullAt, set, get, isEmpty } from 'lodash';
export default {
  name: 'CoreDtwinRuleEdit',
  props: {
    value: {
      type: Object,
      default: function _default() {
        return {};
      },
      required: false
    },
    // the states that are to be displayed / edited
    states: {
      type: Array,
      required: true
    },
    dtwin: {
      type: Object,
      required: false,
      default: function _default() {}
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false
    },
    hasTwinEditPermission: {
      type: Boolean,
      required: false,
      default: false
    },
    isOpen: {
      type: Boolean,
      default: true
    },
    template: {
      type: Object,
      required: false,
      default: function _default() {}
    },
    isCreatedByTemplate: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data: function data() {
    return {
      formValid: false,
      editedRule: {},
      ruleModeMetricsDisablePrompt: false,
      ruleModes: {
        metrics: true,
        geofences: false
      },
      modeTab: 'metrics',
      // if states are refreshed on a websocket-update, this would also destroy the whole form
      // so make a copy here initially and only use that
      statesCopy: [],
      testStateMetrics: {},
      testResults: null
    };
  },
  computed: _objectSpread(_objectSpread({}, mapState('app', ['inpOutlined', 'inpFilled', 'image', 'color', 'UiTheme'])), {}, {
    isMobile: function isMobile() {
      return this.$vuetify.breakpoint.smAndDown;
    },
    requiredRule: function requiredRule() {
      var _this = this;

      return [function (v) {
        return !!v || parseInt(v) === 0 || _this.$i18n_t('Common.fieldRequired');
      }];
    },
    hourRules: function hourRules() {
      var _this2 = this;

      return [].concat(_toConsumableArray(this.requiredRule), [function (v) {
        return v >= 0 && v < 24 || _this2.$i18n_t('DigitalTwin.DigitalTwin.ruleModeler.timeTriggers.hourRule');
      }]);
    },
    throttleRules: function throttleRules() {
      var _this3 = this;

      return [].concat(_toConsumableArray(this.requiredRule), [function (v) {
        return v >= 0 || _this3.$i18n_t('DigitalTwin.DigitalTwin.ruleModeler.geoFences.numberRule');
      }]);
    },
    executionTimes: function executionTimes() {
      return (get(this.editedRule, 'properties.executionTimes') || []).filter(function (t) {
        return !!get(t, 'time') && t.time.constructor === Object;
      });
    },
    timeTriggers: function timeTriggers() {
      return (get(this.editedRule, 'properties.timeTriggers') || []).filter(function (t) {
        return !!get(t, 'time') && t.time.constructor === Object;
      });
    },
    aggregateStates: function aggregateStates() {
      return this.statesCopy.filter(function (state) {
        return ['virtual-device', 'virtual-device-aggregate', 'aggregate', 'timeseries-aggregate'].indexOf(state.properties.binding.type) >= 0;
      });
    },
    isTemplateContext: function isTemplateContext() {
      return !isEmpty(this.template);
    }
  }),
  watch: {
    value: function value() {
      if (!get(this.editedRule, 'properties') || get(this.value, 'id') !== get(this.editedRule, 'id')) {
        if (get(this.value, 'properties')) {
          this.editedRule = cloneDeep(this.value);
        } else {
          this.createDefaultRule();
        }
      }

      this.addTimeTriggerDefault();
      this.addGeoFenceDefault();
      this.addTriggeredAggregatesDefault();
      this.ruleModes.metrics = this.editedRule.properties.stateMetrics.length > 0;
      this.ruleModes.geofences = this.editedRule.properties.geoFences.length > 0;
    },
    states: function states() {
      if (this.statesCopy.length === 0) {
        this.statesCopy = cloneDeep(this.states);
      }
    }
  },
  created: function created() {
    this.createDefaultRule();
  },
  mounted: function mounted() {
    if (get(this.value, 'properties')) {
      this.editedRule = cloneDeep(this.value);
    }

    this.addExecutionTimeDefault();
    this.addTimeTriggerDefault();
    this.addGeoFenceDefault();
    this.addTriggeredAggregatesDefault();

    if (get(this.value, 'properties')) {
      this.ruleModes.metrics = this.editedRule.properties.stateMetrics.length > 0;
      this.ruleModes.geofences = this.editedRule.properties.geoFences.length > 0;
    }

    this.statesCopy = cloneDeep(this.states);

    if (this.editedRule.id) {
      // validate form for editing rules
      // to highlight incorrectly linked states immediately
      this.$refs.form.validate();
    }
  },
  methods: {
    addExecutionTimeDefault: function addExecutionTimeDefault() {
      if (!get(this.editedRule, 'properties.executionTimes') || !isArray(get(this.editedRule, 'properties.executionTimes'))) {
        this.editedRule.properties.executionTimes = [];
      }

      this.editedRule.properties.executionTimes = (get(this.editedRule, 'properties.executionTimes') || []).filter(function (t) {
        return !!get(t, 'startTime') && t.startTime.constructor === Object;
      });
    },
    addTimeTriggerDefault: function addTimeTriggerDefault() {
      // if (
      //   !get(this.editedRule, 'properties.timeTriggers[0].time') ||
      //   get(this.editedRule, 'properties.timeTriggers[0].time').constructor !== Object
      // ) {
      //   this.editedRule.properties.timeTriggers = [{ timeZone: momentTZ.tz.guess(), time: { hourly: false } }];
      // }
      if (!get(this.editedRule, 'properties.timeTriggers') || !isArray(get(this.editedRule, 'properties.timeTriggers'))) {
        this.editedRule.properties.timeTriggers = [];
      }

      this.editedRule.properties.timeTriggers = (get(this.editedRule, 'properties.timeTriggers') || []).filter(function (t) {
        return !!get(t, 'time') && t.time.constructor === Object;
      });
    },
    addGeoFenceDefault: function addGeoFenceDefault() {
      if (!get(this.editedRule, 'properties.geoFences') || !isArray(get(this.editedRule, 'properties.geoFences'))) {
        this.editedRule.properties.geoFences = [];

        if (this.editedRule.properties.conditionEnabled === undefined) {
          this.editedRule.properties.conditionEnabled = true;
        }
      }
    },
    addTriggeredAggregatesDefault: function addTriggeredAggregatesDefault() {
      if (!get(this.editedRule, 'properties.triggeredAggregates') || !isArray(get(this.editedRule, 'properties.triggeredAggregates'))) {
        this.editedRule.properties.triggeredAggregates = [];
      }
    },
    createDefaultRule: function createDefaultRule() {
      if (get(this.value, 'properties')) {
        this.editedRule = cloneDeep(this.value);
      } else {
        this.editedRule = {
          stateIds: [],
          properties: {
            executionTimes: [],
            timeTriggers: [],
            geoFences: [],
            stateMetrics: [],
            conditions: {
              type: 'and',
              items: []
            },
            actions: [],
            triggeredAggregates: [],
            conditionEnabled: true
          }
        };
        this.editRuleAddState(0);
      }
    },
    stateMetricModeChanged: function stateMetricModeChanged() {
      if (!this.ruleModes.metrics) {
        this.ruleModeMetricsDisablePrompt = true;
      } else {
        this.toggleStateMetricMode();
      }
    },
    toggleStateMetricMode: function toggleStateMetricMode() {
      this.editedRule.properties.conditionEnabled = true;

      if (!this.ruleModes.metrics) {
        this.editedRule.properties.stateMetrics = [];
      } else {
        if (this.editedRule.properties.stateMetrics.length === 0) {
          this.editRuleAddState(0);
        }
      }
    },
    toggleGeofenceMode: function toggleGeofenceMode() {
      if (!this.ruleModes.geofencing) {
        this.editedRule.properties.geoFences = [];
      }
    },
    toggleRuleState: function toggleRuleState() {
      this.editedRule.properties.disabled = !get(this.editedRule, 'properties.disabled', false);
      this.editedRule = cloneDeep(this.editedRule);
      this.saveRule();
    },
    editRuleAddState: function editRuleAddState(index) {
      this.editedRule.properties.stateMetrics.splice(index, 0, {
        history: {
          count: 1,
          useCount: true,
          minutes: 60,
          useMinutes: true,
          abortIfNull: true
        },
        transform: 'x',
        operation: 'last'
      });
      this.editedRule = cloneDeep(this.editedRule);
    },
    editRuleDeleteState: function editRuleDeleteState(index) {
      var stateMetricKey = this.editedRule.properties.stateMetrics[index].key;

      var filterConditions = function filterConditions(conditions) {
        conditions.items = conditions.items.filter(function (cond) {
          if (!!cond.compOperator) {
            return cond.key !== stateMetricKey;
          } else {
            filterConditions(cond);
            return true;
          }
        });
      };

      filterConditions(this.editedRule.properties.conditions);
      pullAt(this.editedRule.properties.stateMetrics, [index]);

      if (this.editedRule.properties.stateMetrics.length === 0) {
        this.editRuleAddState(0);
      }

      this.editRuleGenerateCleanStateIds();
      this.editedRule = cloneDeep(this.editedRule);
    },
    editRuleAddGeoFence: function editRuleAddGeoFence(index) {
      this.editedRule.properties.geoFences.splice(index, 0, {});
      this.editedRule = cloneDeep(this.editedRule); // highlight the twin-finder field

      this.$refs['form'].validate();
    },
    editRuleDeleteGeoFence: function editRuleDeleteGeoFence(index) {
      pullAt(this.editedRule.properties.geoFences, [index]);
      this.editedRule = cloneDeep(this.editedRule);
    },
    editRuleAddExecutionTime: function editRuleAddExecutionTime(index) {
      this.editedRule.properties.executionTimes.splice(index, 0, {
        timeZone: momentTZ.tz.guess(),
        startTime: {},
        endTime: {},
        weekDays: [this.$i18n_t('Common.AllDays')],
        monthDays: [this.$i18n_t('Common.AllDays')]
      });
      this.editedRule = cloneDeep(this.editedRule);
    },
    editRuleDeleteExecutionTime: function editRuleDeleteExecutionTime(index) {
      pullAt(this.editedRule.properties.executionTimes, [index]);
      this.editedRule = cloneDeep(this.editedRule);
    },
    editRuleAddTimeTrigger: function editRuleAddTimeTrigger(index) {
      this.editedRule.properties.timeTriggers.splice(index, 0, {
        timeZone: momentTZ.tz.guess(),
        time: {
          hourly: false
        }
      });
      this.editedRule = cloneDeep(this.editedRule);
    },
    editRuleDeleteTimeTrigger: function editRuleDeleteTimeTrigger(index) {
      pullAt(this.editedRule.properties.timeTriggers, [index]);

      if (this.editedRule.properties.timeTriggers.length === 0) {
        // if the last time-trigger is removed, also auto-disable (if it even was enabled) the "time-trigger-only" option
        // will show the other options like time-trigger conditons and JS-conditions and such again in the UI
        this.editedRule.properties.timeTriggerOnly = false;
      }

      this.editedRule = cloneDeep(this.editedRule);
    },
    editRuleDeleteAction: function editRuleDeleteAction(index) {
      pullAt(this.editedRule.properties.actions, [index]);
      this.editedRule.properties.actions = cloneDeep(this.editedRule.properties.actions);
    },
    handleCommandChanged: function handleCommandChanged(index) {
      var selectedCommand = this.editedRule.properties.actions[index];
      var selectedCommandName = selectedCommand.command;
      var initalCommand = get(this.value, "properties.actions[".concat(index, "]")) || {};
      var initalCommandName = initalCommand.command;
      selectedCommand.params = selectedCommandName === initalCommandName ? initalCommand.params : {};
    },
    editRuleAddAggregate: function editRuleAddAggregate(index) {
      this.editedRule.properties.triggeredAggregates.splice(index, 0, {});
      this.editedRule.properties = cloneDeep(this.editedRule.properties);
    },
    editRuleDeleteAggregate: function editRuleDeleteAggregate(index) {
      pullAt(this.editedRule.properties.triggeredAggregates, [index]);
      this.editedRule.properties.triggeredAggregates = cloneDeep(this.editedRule.properties.triggeredAggregates);
    },
    editRuleGenerateCleanStateIds: function editRuleGenerateCleanStateIds() {
      var stateIds = [];
      this.editedRule.properties.stateMetrics.forEach(function (sm) {
        if (sm.stateId) {
          if (stateIds.findIndex(function (sid) {
            return sid === sm.stateId;
          }) < 0) {
            stateIds.push(sm.stateId);
          }
        } else if (sm.id) {
          if (stateIds.findIndex(function (sid) {
            return sid === sm.id;
          }) < 0) {
            stateIds.push(sm.id);
          }
        }
      });
      this.editedRule.stateIds = stateIds;
    },
    testRule: function testRule() {
      var _this4 = this;

      var finalStateMetricValues = {}; // make sure JSON objects are handled correctly
      // strings, bools, numbers should be unaffected still

      Object.keys(this.testStateMetrics).forEach(function (metricKey) {
        try {
          finalStateMetricValues[metricKey] = JSON.parse(_this4.testStateMetrics[metricKey]);
        } catch (_) {
          // if the JSON cannot be parsed, interpret it as string directly
          finalStateMetricValues[metricKey] = _this4.testStateMetrics[metricKey];
        }
      });
      return ApiService.digitalTwinRuleTest(this, {
        rule: this.editedRule,
        stateValues: finalStateMetricValues
      }).then(function (result) {
        Object.keys(result.ruleMetrics).forEach(function (metricKey) {
          if (result.ruleMetrics[metricKey] === null) {
            // make sure null values are displayed in the UI
            result.ruleMetrics[metricKey] = 'null';
          }
        });
        _this4.testResults = result;
      });
    },
    didSelectState: function didSelectState(stateMetric) {
      var _this5 = this;

      if (!stateMetric.key || stateMetric.key.trim() === '') {
        var matchIdentifier = this.isTemplateContext ? 'key' : 'id';
        var identifier = this.isTemplateContext ? 'id' : 'stateId';
        stateMetric.key = this.statesCopy.find(function (s) {
          var identifierValue = _this5.isTemplateContext ? stateMetric[identifier].toLowerCase() // string from template
          : stateMetric[identifier]; // actual state number

          return s[matchIdentifier] === identifierValue;
        }).key.replace(/[\0-\/:-@\[-`\{-\uFFFF]/i, '');
      }

      if (!this.$refs.metrics.stateIsNumeric(stateMetric)) {
        // for all non-numeric values there is no offering of any operation but "LAST", so it makes no sense to allow a history
        stateMetric.history.count = 1;
        stateMetric.history.useCount = true;
      }

      this.editRuleGenerateCleanStateIds();

      if (!get(this.editedRule, 'properties.conditions.items')) {
        set(this.editedRule, 'properties.conditions.items', []);
      }

      if (get(this.editedRule, 'properties.conditions.items.length') === 0) {
        this.editedRule.properties.conditions.items.push({
          key: stateMetric.key,
          compOperator: 'gt',
          compValue: 0
        });
      }

      this.validateForm();
    },
    refreshForm: function refreshForm() {
      this.editedRule = cloneDeep(this.editedRule);
    },
    validateForm: function validateForm() {
      this.$refs.form.validate();
    },
    saveRule: function saveRule() {
      this.$emit('save', this.editedRule);
    }
  }
};